var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item-field",attrs:{"data-key":_vm.kebabCase(_vm.item.key)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }